/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Rcnv_Quote_AfterInputs */

const es_landing_rcnv_quote_after = /** @type {(inputs: Landing_Rcnv_Quote_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Además, ayudamos a que socios del náutico tengan un ingreso extra.`)
};

const gl_landing_rcnv_quote_after = /** @type {(inputs: Landing_Rcnv_Quote_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Ademais, axudamos a que socios do náutico teñan un ingreso extra.`)
};

const en_landing_rcnv_quote_after = /** @type {(inputs: Landing_Rcnv_Quote_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` We also help club members earn extra income.`)
};

/**
* | output |
* | --- |
* | "We also help club members earn extra income." |
*
* @param {Landing_Rcnv_Quote_AfterInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_rcnv_quote_after = /** @type {((inputs?: Landing_Rcnv_Quote_AfterInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Rcnv_Quote_AfterInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_rcnv_quote_after(inputs)
	if (locale === "en") return en_landing_rcnv_quote_after(inputs)
	return es_landing_rcnv_quote_after(inputs)
});